// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import SecurityTag from '@Atoms/Info/SecurityTag/SecurityTag';
import { SecurityTagType } from '@Types';

import './SecurityInput.scss';

type SecurityValues = number;

interface SecurityInputProps<T extends SecurityValues> {
    type: SecurityTagType;
    hasLabel?: boolean;
    valueArray: readonly T[];
    value?: T;
    onChange?: (value: T) => void;
}

export const SecurityInput = <T extends SecurityValues>({
    type = 'tlp',
    valueArray = [],
    hasLabel = true,
    value,
    onChange,
}: SecurityInputProps<T>): ReactElement => {
    return (
        <div className="security-input__list">
            {valueArray.map((securityValue) => (
                <div
                    key={`security-value-${securityValue}`}
                    onClick={(): void => onChange?.(securityValue)}
                    role="button"
                    className={`security-input ${securityValue === value ? 'selected' : ''}`}
                >
                    <SecurityTag
                        fillType={securityValue === value ? 'fill' : 'outline'}
                        type={type}
                        value={securityValue}
                        hasLabel={hasLabel}
                        uncolored={securityValue !== value}
                    />
                </div>
            ))}
        </div>
    );
};
